import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

import { OfferUnitSearchRequest, OfferUnit, PagedResponse } from '@core/api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OfferUnitService {
  constructor(private http: HttpClient) { }

  search(request: OfferUnitSearchRequest): Observable<PagedResponse<OfferUnit>> {
    return this.http.post<PagedResponse<OfferUnit>>(environment.apiUrl + '/api/OfferUnit/Search', request);
  }
}
